import MarkerOption from "./MarkerOption";
import styles from "./MarkerOptions.module.scss";
import { useContext } from "react";
import { Context as LanguageContext } from "../../Context/LanguageContext";

const MarkerOptions = ({
  markerOptions,
  markerOptionsAction,
  isTrafficForecastAvailable,
  trafficForecast,
  switchTrafficForecast,
}) => {
  const languageContext = useContext(LanguageContext);

  if (!markerOptions) return null;

  const organiseByHeading = (array) => {
    const enrichedArray = array.map((element, index) => ({
      ...element,
      index,
      heading: element.heading || "",
    }));

    return Object.values(
      enrichedArray.reduce((acc, element) => {
        const { heading } = element;
        acc[heading] = acc[heading] || [];
        acc[heading].push(element);
        return acc;
      }, {})
    );
  };

  const organisedMarkers = organiseByHeading(markerOptions);

  return (
    <>
      {organisedMarkers.map((group, groupIndex) =>
        group.map((markerOption, index) => {
          const { marker, heading, localisedHeading, isLoading, isFocused } =
            markerOption;

          if (!marker?.icon) return null;

          const markerName =
            marker?.localisedName?.find(
              (textValue) => textValue.languageCode === languageContext.locale
            )?.value ?? marker.name;

          const headingName =
            localisedHeading?.find(
              (textValue) => textValue.languageCode === languageContext.locale
            )?.value ?? heading;

          return (
            <>
              {index === 0 && (
                <div style={{ width: "100%" }}>
                  <b className={styles["modal-subtitle"]}>{headingName}</b>
                </div>
              )}
              <div onClick={() => markerOptionsAction(markerOption.index)}>
                <MarkerOption
                  index={index}
                  markerOptionsCount={markerOptions.length}
                  param={marker.icon}
                  active={isFocused}
                  loading={isLoading}
                  text={markerName}
                />
              </div>
            </>
          );
        })
      )}
      {isTrafficForecastAvailable && (
        <div onClick={switchTrafficForecast}>
          <MarkerOption
            index={markerOptions.length}
            param={"exclamation"}
            active={trafficForecast}
            loading={false}
            text={"Disruptions"}
          />
        </div>
      )}
    </>
  );
};

export default MarkerOptions;
